// =====================================================================
// My Agency V2 — CMP-PHONE, international phone input v3
// (ARTBOARD-SPEC §4 CMP-PHONE + board 3b country code selector).
//
// PRESENTATION ONLY. The behavior is the platform's existing phone
// logic: the same react-phone-input-2 instance with the prop set of
// components/common/CustomPhoneInput.js (enableSearch,
// preferredCountries, specialLabel:""). onChange keeps the library
// signature (value, countryData) so callers capture ISO2 exactly as
// before.
//
// T052 — three props deviate from CustomPhoneInput, because that prop
// set silently ALTERED what the user typed:
//   • enableLongNumbers — without it the library trims the input to the
//     selected country's mask, so a 10-digit number typed into a France
//     field lost its last digit with no message at all. With it the
//     overflow is kept and the caller's per-country validation (I-2)
//     flags the number instead of the input quietly rewriting it.
//   • countryCodeEditable — with the dial code locked, pasting a
//     foreign number ("+1 202 555 0140" into a +33 field) was discarded
//     outright and the field snapped back to "+33". Editable lets the
//     library resolve the country from what was pasted, which is the
//     behaviour board 3a documents ("Pasting '+41 79 266 44 12'
//     auto-selects Switzerland.").
//   • country default "" — no country is assumed unless the caller
//     resolves one. The old 'fr' default was arbitrary (see the
//     resolution chain in AgentInvitationModal).
// The v3 look (flag-chip trigger, SYM-04/05 chevrons, 260px country
// popover with SYM-07 search) is applied in PhoneField.css, scoped
// under .tpv2-phone (Brief Rules 6/8/11 — restyle, never rewire).
// =====================================================================
import React from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "./PhoneField.css";

const PhoneField = ({
  value,
  onChange,
  placeholder,
  disabled = false,
  error = false,
  mobile = false,
  searchPlaceholder = "Search country...",
  ...rest
}) => (
  <div
    className={[
      "tpv2-phone",
      mobile ? "tpv2-phone--mobile" : "",
      error ? "tpv2-phone--error" : "",
    ]
      .filter(Boolean)
      .join(" ")}
  >
    <PhoneInput
      country={""}
      value={value}
      onChange={onChange}
      disabled={disabled}
      enableSearch={true}
      searchPlaceholder={searchPlaceholder}
      placeholder={placeholder}
      specialLabel=""
      preferredCountries={["fr", "gb", "us", "de", "es"]}
      countryCodeEditable={true}
      enableLongNumbers={true}
      {...rest}
    />
  </div>
);

export default PhoneField;
